import React from 'react';
import { formatCurrency } from './utils';

export default function ContractDetails({ res, workflow }) {
    return (
        <div className="db-two-col-card">
            <div className="db-card-header">
                <span className="db-card-title">Contract &amp; SREC Details</span>
            </div>
            <div className="db-card-body">
                <div className="db-detail-grid">
                    <div>
                        <div className="db-detail-label">Application Type</div>
                        <div className="db-detail-value">{workflow?.label ?? '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">Tracking System</div>
                        <div className="db-detail-value">{res.tracking_system_name ?? '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">System Size (DC)</div>
                        <div className="db-detail-value">{res.kw_dc != null ? `${res.kw_dc} kW` : '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">System Size (AC)</div>
                        <div className="db-detail-value">{res.kw_ac != null ? `${res.kw_ac} kW` : '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">REC Price</div>
                        <div className="db-detail-value db-detail-value--green">
                            {res.rec_price != null ? `${formatCurrency(res.rec_price)} / REC` : '—'}
                        </div>
                    </div>
                    <div>
                        <div className="db-detail-label">Est. Annual RECs</div>
                        <div className="db-detail-value">{res.annual_recs ?? '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">Contract Status</div>
                        <div className="db-detail-value">{res.contract_status ?? '—'}</div>
                    </div>
                    <div>
                        <div className="db-detail-label">Certification State</div>
                        <div className="db-detail-value">{res.state ?? res.certification_state ?? '—'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
